import React from 'react';

import {
  assignTagsToRSimProduct,
  createRSimProductTag,
  fetchAssignedTagToRSimProduct,
  fetchRSimProductTag,
  fetchRSimProductTags,
} from './services/tagsRSimProducts';
import { CARD_TYPE } from '../../tags/models/schemas';
import { TagContext } from '../../tags/context/tagContext';

type TagProviderProps = {
  children: React.ReactNode;
};

const RSIM_PRODUCT_TAGS_CONTENT_API = {
  assignTags: assignTagsToRSimProduct,
  fetchTag: fetchRSimProductTag,
  fetchAssignedTags: fetchAssignedTagToRSimProduct,
  createTag: createRSimProductTag,
  fetchTags: fetchRSimProductTags,
  type: CARD_TYPE.RSIM,
  isProduct: true,
};

export const RSimProductTagProvider = ({ children }: TagProviderProps) => {
  return (
    <TagContext.Provider value={RSIM_PRODUCT_TAGS_CONTENT_API}>{children}</TagContext.Provider>
  );
};
